// extracted by mini-css-extract-plugin
export var addButton = "_el-0";
export var border = "_el-8";
export var check = "_el-h";
export var danger = "_el-6";
export var dropdownContainer = "_el-1";
export var editModalBody = "_el-j";
export var footerContainer = "_el-i";
export var fullWidth = "_el-a";
export var hide = "_el-9";
export var icon = "_el-3";
export var input = "_el-7";
export var inputFlex = "_el-b";
export var inputWrapper = "_el-c";
export var manualFocus = "_el-5";
export var optionButton = "_el-4";
export var pillWrapper = "_el-e";
export var pointer = "_el-2";
export var showOverflow = "_el-f";
export var tagsFlex = "_el-d";
export var xButton = "_el-g";